import { formatBytes, DocumentViewer, ProviderDocument, ProviderDocumentUrl, Spinner } from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RootStore } from 'stores';
import * as S from './claim-timeline-table.styles';

interface IDocumentDetailProps {
    document: ProviderDocument;
}

export const DocumentDetail: React.FunctionComponent<IDocumentDetailProps> = inject('rootStore')(
    observer(
        (props: IDocumentDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const { document } = props;
            const [loading, setLoading] = useState(false);
            const [documentUrl, setDocumentUrl] = useState<ProviderDocumentUrl | undefined>();

            useEffect(() => {
                (async (): Promise<void> => {
                    if (document && document.id) {
                        setLoading(true);
                        const url = await claimStore.loadDocumentDownloadUrl(document.id, document.documentType);
                        setLoading(false);
                        setDocumentUrl(url);
                    }
                })();
            }, [document, claimStore]);

            return (
                <S.ExpandContainer>
                    <S.ExpandTable>
                        <S.ExpandTBody>
                            {loading && (
                                <S.ExpandTR>
                                    <S.ExpandTD colSpan={2}>
                                        <Spinner />
                                    </S.ExpandTD>
                                </S.ExpandTR>
                            )}
                            {!loading && (
                                <>
                                    <S.ExpandTR>
                                        <S.ExpandTD>{document.description}</S.ExpandTD>
                                    </S.ExpandTR>
                                    {!!document.filesize && document.filesize > 0 && (
                                        <S.ExpandTR>
                                            <S.ExpandTH>Filesize</S.ExpandTH>
                                            <S.ExpandTD>{formatBytes(document.filesize)}</S.ExpandTD>
                                        </S.ExpandTR>
                                    )}
                                </>
                            )}
                        </S.ExpandTBody>
                    </S.ExpandTable>
                    {documentUrl?.url && <DocumentViewer url={documentUrl.url} />}
                </S.ExpandContainer>
            );
        },
    ),
);
